var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "filter-container" }, [
    _c("div", { staticClass: "filter-item" }, [
      _c("label", [_vm._v("年份")]),
      _c(
        "div",
        { staticClass: "filter-select" },
        _vm._l(_vm.yearList, function (item, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "select-item",
              attrs: { "data-actived": item === _vm.currentYear },
              on: {
                click: function ($event) {
                  return _vm.changeYear(item)
                },
              },
            },
            [_vm._v(" " + _vm._s(item) + " ")]
          )
        }),
        0
      ),
    ]),
    _c("div", { staticClass: "filter-item" }, [
      _c("label", [_vm._v("直播")]),
      _c(
        "div",
        { staticClass: "filter-select" },
        _vm._l(_vm.typeList, function (item) {
          return _c(
            "div",
            {
              key: item.id,
              staticClass: "select-item",
              attrs: { "data-actived": item.id === _vm.currentType.id },
              on: {
                click: function ($event) {
                  return _vm.changeType(item)
                },
              },
            },
            [_vm._v(" " + _vm._s(item.name) + " ")]
          )
        }),
        0
      ),
    ]),
    _c("div", { staticClass: "filter-item" }, [
      _c("label", [_vm._v("状态")]),
      _c(
        "div",
        { staticClass: "filter-select" },
        _vm._l(_vm.statusList, function (item) {
          return _c(
            "div",
            {
              key: item.id,
              staticClass: "select-item",
              attrs: { "data-actived": item.id === _vm.currentStatus.id },
              on: {
                click: function ($event) {
                  return _vm.changeStatus(item)
                },
              },
            },
            [_vm._v(" " + _vm._s(item.name) + " ")]
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }